<template>
  <div class="div">
    <div class="gs-worp">
      <!-- 顶部tab -->
      <div class="gs-tab">
        <ul>
          <li
            class="xs"
            v-for="(btn , index) in tab"
            :key="index"
            :class="{gsactive:nowindex == index}"
            @click="tabswitch(index)"
          >{{btn.name}}</li>
          <!-- <span v-if="ishongdian" class="reddian"></span> -->
        </ul>
      </div>
      <div class="gs-none">
        <!-- <div :class="{gsqiye:nowindex == 0}"> -->
        <!-- 企业列表展示-------添加企业-------------企业详细信息展示 ---------------------------- -->
        <!-- <keep-alive> -->
        <!-- <router-view></router-view> -->
        <!-- </keep-alive> -->
        <!-- </div> -->

        <!-- 企业信息 ------------------------------------------------------------------>
        <div :class="{gsqiye:nowindex == 0}">
          <div v-if="ismodifycompany" class="over gr-worp" style="margin-bottom: 100px;">
            <div class="left gr-right wspace" style="margin-bottom: 50px;">
              <div class="infoTitle">企业信息</div>
              <ul style="padding:0;">
                <li>
                  <span>企业名称：</span>
                  <span style="display:inline-block;width:270px;">{{companyInfo.name}}</span>
                  <button class="modifyname dianji" @click="modify('company')">修改</button>
                </li>
                <li>
                  <span>服务类型：</span>
                  <span>{{apptype=="make-app"?"制造云":(apptype=="trade-app"?"贸易云":"")}}</span>
                </li>
                <li>
                  <span>企业UU：</span>
                  <span>{{companyInfo.uu}}</span>
                </li>
                <li>
                  <span>纳税人识别号：</span>
                  <span>{{companyInfo.businessCode}}</span>
                </li>
              </ul>
              <div v-if="isadminiinfo" class="space"></div>
              <div v-if="isadminiinfo" class="infoTitle">管理员信息</div>
              <ul style="padding:0;">
                <li v-for="(d,i) in adminList" :key="i">
                  <span>姓名：</span>
                  <span style="width:60px;display:inline-block;">{{d.realname}}</span>
                  <span class="admininfo">手机号码：</span>
                  <span>{{d.mobile}}</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- 修改公司名称 --------------------------------------------------------------->
          <div v-if="!ismodifycompany" class="over gr-worp" style="margin-bottom: 100px;">
            <div class="left gr-right wspace" style="margin-bottom: 50px;">
              <div class="infoTitle">企业信息</div>
              <ul style="padding:0;">
                <li>
                  <span class="xinghao">企业名称：</span>
                  <input
                    style="width:270px;"
                    @focus="hideregname('company')"
                    @blur="regcompany"
                    type="text"
                    ref="companyname"
                  />
                  <span :key="'company'" class="usname" v-show="isuscompany" ref="uscompany"></span>
                  <button class="baocun dianji" @click="PreservationCompanyInfo">保存</button>
                  <button class="qy-quxiao quxiao" @click="cancel('company')">取消</button>
                </li>
                <li>
                  <span>服务类型：</span>
                  <span>{{mytoken.defaultCompany.app=="make-app"?"制造云":(mytoken.defaultCompany.app=="trade-app"?"贸易云":"")}}</span>
                </li>
                <li>
                  <span>企业UU：</span>
                  <span>{{companyInfo.uu}}</span>
                </li>
                <li>
                  <span>纳税人识别号：</span>
                  <span>{{companyInfo.businessCode}}</span>
                </li>
                <div v-if="isadminiinfo" class="space"></div>
                <div v-if="isadminiinfo" class="infoTitle">管理员信息</div>
                <ul style="padding:0;">
                  <li v-for="(d,i) in adminList" :key="i">
                    <span>姓名：</span>
                    <span style="width:60px;display:inline-block;">{{d.realname}}</span>
                    <span class="admininfo">手机号码：</span>
                    <span>{{d.mobile}}</span>
                  </li>
                </ul>
              </ul>
            </div>
          </div>
        </div>

        <!-- 个人信息------------------------------------------------------------------- -->
        <div :class="{gsqiye:nowindex == 1}">
          <div v-if="ismodifyname" class="over gr-worp" style="margin-bottom: 100px;">
            <div class="left gr-right wspace" style="margin-bottom: 50px;">
              <div class="infoTitle">个人信息</div>
              <ul style="padding:0">
                <li>
                  <span>姓名：</span>
                  <span style="display: inline-block;width:270px">{{mytoken.realname}}</span>
                  <button class="modifyname dianji" @click="modify">修改</button>
                </li>
                <li>
                  <span>UU号：</span>
                  <span>{{mytoken.uu}}</span>
                </li>
                <li>
                  <span>邮箱：</span>
                  <span>{{mytoken.email}}</span>
                </li>
                <li>
                  <span>手机号：</span>
                  <span>{{mytoken.mobile}}</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- 修改页面 -->
          <div v-else class="over gr-worp" style="margin-bottom: 100px;">
            <div class="left gr-right wspace" style="margin-bottom: 30px;">
              <div class="infoTitle">个人信息</div>
              <ul style="padding:0;">
                <li>
                  <span class="xinghao">姓名：</span>
                  <input
                    style="width:270px;"
                    @blur="regname"
                    @focus="hideregname"
                    class="realname"
                    type="text"
                    ref="realname"
                    value
                  />
                  <span v-show="isusname" class="usname" ref="usname"></span>
                  <button class="baocun dianji" @click="Preservation">保存</button>
                  <button class="qy-quxiao quxiao" @click="cancel">取消</button>
                </li>
                <li>
                  <span>UU号：</span>
                  <span>{{mytoken.uu}}</span>
                </li>
                <li>
                  <span>邮箱：</span>
                  <span>{{mytoken.email}}</span>
                </li>
                <li>
                  <span>手机号：</span>
                  <span>{{mytoken.mobile}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 安全信息----------------------------------------------------------------------------- -->

        <div :class="{gsqiye:nowindex == 2}">
          <div class="gs-anquanxinxi">
            <div class="over aq-title">
              <span class="left">登录密码</span>
              <a :href="$url.accountCenter + '/resetPassword'" target="_blank" class="right dianji">更换密码</a>
            </div>
            <div class="aq-text">
              <p>安全性高的密码可以使账号更安全，建议您定期更换密码，并且设置一个包含数字和字母，长度超过8位以上的密码。</p>
            </div>
          </div>
          <div class="gs-anquanxinxi">
            <div class="over aq-title">
              <span class="left">手机验证</span>
              <a :href="$url.accountCenter + '/validationMobile.html'" target="_blank" class="right dianji">修改手机号</a>
            </div>
            <div class="aq-text">
              <p>您绑定的手机：{{mobile}}。若已丢失或停用，请立即更换，避免账户被盗。</p>
            </div>
          </div>
        </div>

        <!-- 消息 ------------------------------------------------------------------>
        <div :class="{gsqiye:nowindex == 4}" style="margin-top: 40px;">
          <div class="gs-news" ref="qiyebox" :class="isheigh ? 'heigh' : ''">
            <ul>
              <li>
                <span>内容</span>
                <span>状态</span>
                <span>时间</span>
              </li>
              <li
                v-if="isnews"
                class="newslist"
                v-for="(d, i) in arr"
                :key="i"
                :class="{newslist2:i%2==0}"
              >
                <span>
                  <span>申请加入</span>
                  <span style="color: #1E88F5;">【{{d.companyName}}】</span>
                  <span>管理员-{{d.admin}}</span>
                  <span>{{d.adminMobile}}</span>
                </span>
                <span v-if="d.status == 0" style="color: #FF3900;">未通过</span>
                <span v-else-if="d.status == 1" style="color: #3CC600;">已通过</span>
                <span v-else-if="d.status == 2" style="color: #1E88F5;">待批准</span>
                <span>{{d.createTime}}</span>
              </li>
              <li v-if="!isnews" class="wushuju">
                <img src="/static/img/zanwushuju2x.png" alt />
                <p>暂无消息</p>
              </li>
            </ul>
            <div v-if="isnews" class="my-pagination">
              <el-pagination
                background
                :page-size="size"
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :total="listtotal"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Session from "@/utils/session";
import { setTimeout } from "timers";
export default {
  data() {
    return {
      nowindex: 0, //tab切换
      tianjiaqiye: true, //添加企业切换
      mytoken: Session.get().account, //本地储存的用户信息
      mobile: null,
      ismodifyname: true,
      isname: true, //姓名验证
      isusname: false,
      reg: new RegExp(/[\@\#\$\%\&\*!！\￥]/), //非法字符
      isheigh: false, //默认高度
      isnews: false,
      tab: [
        { name: "企业信息" },
        { name: "个人信息" },
        { name: "安全设置" },
        // { name: "消息" }
      ],
      arr: [], //分页数据
      list: [], //全部数据
      listtotal: 1,
      size: 10, //每页显示数量
      companyInfo: {},
      adminList: [],

      authorization:Session.getToken(),
      ismodifycompany: true,
      isuscompany: false,
      iscompanynameright: true, //校验公司名称
      isadminiinfo: false,      //是否有管理员信息
      apptype:null       //公司服务类型
    };
  },
  created() {
    if (!this.mytoken) {
      this.$router.push({ path: "/home" });
    }
    this.scrollout();

    this.$ajax({
      url: this.$url.api + "/api/account/company/read/current",
      method: "get",
      headers: {
        Authorization: this.authorization || ""
      },
    }).then((res) => {
      if (res.data.success) {
        this.companyInfo = res.data.data;

        let companies = this.mytoken.companies;
        let company = companies.filter((item)=>{
            return item.name == res.data.data.name;
        })
        this.apptype = company[0].app;   //current接口没有返回公司服务类型，从info接口的公司列表中获取

        if (res.data.data.accountDTOList) {
          this.isadminiinfo = true;
          this.adminList = res.data.data.accountDTOList.slice(0, 5); //取前5条管理员信息
        }
      }
    });
  },
  mounted() {
    let phone = this.mytoken.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    this.mobile = phone;
    // this.boxheight();
  },
  watch: {
    arr: function () {
      this.$nextTick(function () {
        this.boxheight();
        if (this.arr != "") {
          this.isnews = true;
        }
      });
    }
  },
  computed: {
    //红点
    ishongdian() {
      // return this.$store.state.ishongdian;
    }
  },
  methods: {
    // tab切换
    tabswitch(index) {
      this.mytoken = Session.get().account;
      if (index == 4) {
        this.nowindex = 4;
        let id = this.mytoken.id;
        let param = [
          {
            type: "condition",
            value: "creatorId=" + id
          }
        ];
        // tab切换到消息的时候获取申请列表
        this.$store.state.isloading = true;
        let _this = this;
        $.ajax({
          url: this.$url.api + "/api/commons/remind/apply/list",
          type: "GET",
          data: {
            condition: JSON.stringify(param),
            number: 1,
            size: 1000
          },
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: Session.getToken()
          },
          success: function (res) {
            _this.$store.state.isloading = false;
            if (res.success) {
              // _this.list = res.data.list;
              _this.list = [];
              let list2 = [];
              list2 = res.data.list;
              for (let i = 0; i < list2.length; i++) {
                for (let j = i + 1; j < list2.length; j++) {
                  if (
                    list2[i].companyName == list2[j].companyName &&
                    list2[j].status == 0
                  ) {
                    list2.splice(j, 1);
                  }
                }
                _this.list.push(list2[i]);
              }
              _this.listtotal = _this.list.length;
              _this.pagingtion(1, _this.size);
              // _this.$store.state.ishongdian = false;//红点
            }
          }
        });
      } else {
        this.nowindex = index;
      }
    },
    //重新加入
    Rejoin(i) {
      this.$ajax({
        url: this.$url.api + "/api/account/bind_company/apply",
        method: "POST",
        params: {
          username: this.arr[i].creatorName,
          accountId: this.mytoken.id,
          companyId: this.arr[i].companyId
        },
        headers: {
          Authorization: Session.getToken(),
        }
      }).then((res) => {
        if (res.data.success) {
          this.$message.success("提交成功，待管理员批准");
          this.tabswitch(4); //本页面刷新
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.scrollout();
      this.pagingtion(val, this.size);
    },
    //分页函数
    pagingtion(min, max) {
      //定义一个空数组存放分割的数据
      this.arr = [];
      //对源数组进行分割
      let list = this.list.concat().splice(min * max - max, max);
      //循环插入新数组中进行展示
      for (let i = 0; i < list.length; i++) {
        this.arr.push(list[i]);
      }
    },
    setTurnHome() {
      this.$parent.turnHome = true;
    },
    //退出
    loginout() {
      const frame = window.frames[window.frames.length - 1];
      frame.postMessage("", "*");
      Session.remove();
      window.location.href =
        this.$url.sso + "/api/user/logout?appId=sp&targetUrl=" + window.location.origin;
      // this.$router.push({path:'/home'})
    },
    //修改姓名
    modify(type) {
      if (type == "company") {
        this.ismodifycompany = false;
        setTimeout(() => {
          this.$refs.companyname.value = this.companyInfo.name;
        }, 10);
      } else {
        this.ismodifyname = false;
        setTimeout(() => {
          this.$refs.realname.value = this.mytoken.realname;
        }, 10);
      }
    },
    //取消修改姓名
    cancel(type) {
      if (type == "company") {
        this.ismodifycompany = true;
      } else {
        this.ismodifyname = true;
      }
    },
    regname() {
      this.isusname = true;
      let name = this.$refs.realname.value.replace(/\s+/g, "");
      if (name == "") {
        this.$refs.usname.innerHTML =
          '<img style="width:14px" src="/static/img/warning.png" alt="">';
        this.$message.error("个人姓名不能为空");
        this.isname = false;
      } else {
        if (this.reg.test(name)) {
          this.$refs.usname.innerHTML =
            '<img style="width:14px" src="/static/img/warning.png" alt="">';
          this.$message.error("不能包含非法字符");
          this.isname = false;
        } else {
          this.$refs.usname.innerHTML =
            '<img style="width:14px" src="/static/img/ok.png" alt="">';
          this.isname = true;
        }
      }
    },
    hideregname(type) {
      if (type == "company") {
        this.isuscompany = false;
      } else {
        this.isusname = false;
      }
    },
    // 保存修改姓名
    Preservation() {
      let name = this.$refs.realname.value.replace(/\s+/g, "");
      let id = this.mytoken.id;
      if (name == "") {
        this.$message.error("个人姓名不能为空");
      } else if (this.isname) {
        this.$ajax({
          url: this.$url.api + "/api/account/account/update",
          method: "post",
          data: {
            id: id,
            realname: name
          },
          headers: {
            Authorization: Session.getToken()
          },
        }).then((res) => {
          if (res.data.success) {
            let session = Session.get();
            session.account.realname = name;
            Session.set(session);
            this.$router.go(0);
          }
        });
      } else {
        this.$message.error("姓名不能包含非法字符");
      }
    },

    // 校验公司名字
    regcompany() {
      this.isuscompany = true;
      let name = this.$refs.companyname.value.replace(/\s+/g, "");
      if (name == "") {
        this.$refs.uscompany.innerHTML =
          '<img style="width:14px" src="/static/img/warning.png" alt="">';
        this.$message.error("企业名称不能为空");
        this.iscompanynameright = false;
      } else {
        if (this.reg.test(name)) {
          this.$refs.uscompany.innerHTML =
            '<img style="width:14px" src="/static/img/warning.png" alt="">';
            this.$message.error(" 不能包含非法字符");
          this.iscompanynameright = false;
        } else {
          this.$refs.uscompany.innerHTML =
            '<img style="width:14px" src="/static/img/ok.png" alt="">';
          this.iscompanynameright = true;
        }
      }
    },
    PreservationCompanyInfo() {
      let name = this.$refs.companyname.value.replace(/\s+/g, "");
      if (name == "") {
        this.$message.error("企业名称不能为空");
      } else if (this.iscompanynameright) {
        this.$ajax({
          url: this.$url.api + "/api/account/company/save",
          method: "post",
          data: {
            name: name,
            id: this.mytoken.companyId
          },
          headers: {
            Authorization: Session.getToken() || ""
          },
        }).then((res) => {
          if (res.data.success) {
            let session = Session.get();
            session.account.defaultCompany.name = name;
            Session.set(session);
            this.$router.go(0);
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$message.error("企业名称不能包含非法字符");
      }
    },
    //ele常见问题
    handleSelect() {
      this.navproblem();
    },
    //常见问题
    navproblem() {
      this.$router.push({ name: "Home", params: { isporblem: false } });
      this.$store.commit("problemfalse");
      this.scrollout();
      this.setTurnHome();
    },
    home() {
      this.scrollout();
      this.setTurnHome();
    },
    // 特色
    feature() {
      this.$router.push({ name: "Home", params: { isfeature: "feature" } }); //690
      this.setTurnHome();
    },
    //功能
    service() {
      this.$router.push({ name: "Home", params: { isfeature: "service" } }); //3530
      this.setTurnHome();
    },
    // 下载
    download() {
      this.$router.push({ name: "Home", params: { isfeature: "download" } }); //4190
      this.setTurnHome();
    },
    gohome(e) {
      this.$store.commit("problemtrue");
    },
    scrollout() {
      $(document).scrollTop(0);
    },
    //内容不足500固定高度
    boxheight() {
      let H = this.$refs.qiyebox.offsetHeight;
      if (H < 500) {
        this.isheigh = true;
      } else {
        this.isheigh = false;
      }
    }
  }
};
</script>

<style scoped>
button{
  outline:none;    /*去除button标签点击出现边框 */
}
.div {
  padding-top: 120px;
  background: #fdfdfd;
  background-image: url(/static/img/Pattern@2x@2x.png);
  background-size: 100%;
  padding-bottom: 1px;
  /* background-position-y: 80px; */
}
.heigh {
  height: 500px;
}
.gsqiye div:last-child {
  margin-bottom: 100px;
}

/* ele常见问题 */
.el-menu-demo {
  border-bottom: 0 !important;
  padding: 0px 10px !important;
}
.el-submenu {
  padding: 0px 10px !important;
}
.el-menu-demo >>> div {
  font-size: 16px !important;
  background: #1c1f48 !important;
}
.el-menu-demo >>> .el-submenu__title:hover {
  background: #1c1f48 !important;
}
.el-menu-demo >>> .el-submenu__title {
  padding: 0px !important;
  height: 48px !important;
  line-height: 48px !important;
  border-bottom: 0 !important;
}
.el-menu-item:hover {
  background: #1e88f5 !important;
}
.modifyname {
  margin-left: 20px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.25px;
  text-align: center;
  padding: 5px 20px;
  background: #1e88f5;
  border-radius: 5px;
  border: 0;
}
.baocun {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.25px;
  text-align: center;
  padding: 5px 20px;
  margin-left: 20px;
  background: #1e88f5;
  border-radius: 5px;
  border: 0;
}
.quxiao {
  padding: 5px 20px;
  border-radius: 5px;
}
.realname {
  margin-left: -5px;
  padding-left: 5px;
}
.usname {
  margin-left: 10px;
  color: red;
  font-size: 12px;
}
/* .xinghao {
  float: left;
  margin-left: -10px;
  color: red !important;
} */

/* 消息 */
.gs-news {
  /* width: 130%;
    margin-left: -15%; */
}
.gs-news > img {
  width: 100%;
}
.gs-news > ul {
  padding: 0;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #243a52;
}
.gs-news > ul > li:nth-child(1) {
  font-weight: 600;
  padding: 0px 0px 0px 25px;
}
.gs-news > ul > li > span {
  display: inline-block;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gs-news > ul > li > span:nth-child(1) {
  width: 63%;
}
.gs-news > ul > li > span:nth-child(2) {
  width: 15%;
}
.gs-news > ul > li > span:nth-child(3) {
  width: 20%;
}
.newscentent {
  text-align: left !important;
}
.newscentent span {
  width: 32%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.newslist {
  background: #ffffff;
  height: 40px;
  padding: 0px 0px 0px 25px;
  line-height: 40px;
}
.newslist2 {
  background: #f4f8fc;
}
.news-btn {
  background: #1e88f5;
  border-radius: 2px;
  color: white;
  border: 0;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.25px;
  text-align: center;
  padding: 5px 16px;
}
.reddian {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background: red;
  position: relative;
  top: -5px;
  left: -25px;
}
.my-pagination {
  margin: 0;
  text-align: center !important;
  margin-top: 50px;
}
.wushuju {
  text-align: center;
  border-top: 2px solid #b7d9fb;
  margin-top: 20px;
  padding: 100px 0px;
}
.wushuju > img {
  width: 11%;
}
.wushuju > p {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #bebebe;
  letter-spacing: 0;
  text-align: center;
  line-height: 26px;
}
.xinghao:before {
  content: "*";
  color: red;
}
.infoTitle {
  width: 100px;
  height: 24px;
  border-left: 4px solid #3597d5;
  text-align: center;
  font-size: 16px;
  color: #3597d5;
  line-height: 24px;
  background-color: #f5f8ff;
  margin: 16px 0px 20px 16px;
}
.space {
  width: 96%;
  height: 1px;
  margin: 30px auto;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.45);
}
</style>



// WEBPACK FOOTER //
// src/components/conenter/enterprise.vue